import React from 'react'
import { useHistory } from 'react-router'

import Header from '../../common/components/Header'
import SectionHeader from '../../common/components/SectionHeader'

import UserSettings from './UserSettings'

import { useUser } from '../hooks'
import { useLogout } from '../../auth/hooks'

import styles from './UserPanel.module.css'

const UserPanel = () => {
  const history = useHistory()
  const user = useUser()
  const logout = useLogout()

  return (
    <div>
      <Header>{user.name}</Header>
      <SectionHeader title="Display Settings" />
      <UserSettings />
      <SectionHeader title="Meta" />
      {user.isAdmin && (
        <span className={styles.link} onClick={() => history.push('/admin')}>
          <i className="fa fa-wrench fa-fw"></i>Admin
        </span>
      )}
      <span className={styles.link} onClick={logout}>
        <i className="fa fa-power-off fa-fw"></i>Sign out
      </span>
    </div>
  )
}

export default UserPanel
